import styled from '@emotion/styled';

type Props = {
  'data-test'?: string;
};

const Slider = styled('input')<Props>({
  '&[disabled]': {
    cursor: 'default',
  },

  cursor: 'pointer',
  display: 'block',
  height: '3rem',
  margin: 0,
  opacity: 0,
  padding: 0,
  width: '100%',
});

export default Slider;
